/* ============================================================
   EVRYDAY - Product Card Nuclear Rebuilder v3.1
   v3:   bulletproof multi-card scan + Horizon <picture>/srcset image extraction
   v3.1: the MutationObserver was attached at script-eval time. This file is
         loaded from <head> without defer, so document.body was still null and
         every page threw "Failed to execute 'observe' ... not of type 'Node'",
         which aborted the rest of the IIFE (no observer, no resize rescan).
         Observer setup now waits for the document to be ready.
   ============================================================ */
(function(){
  'use strict';

  function isMobile(){ return window.matchMedia('(max-width: 900px)').matches; }
  function q(root, sel){ try { return root.querySelector(sel); } catch(e) { return null; } }
  function qAll(root, sel){ try { return root.querySelectorAll(sel); } catch(e) { return []; } }
  function qOne(root, selectors){ for (var i = 0; i < selectors.length; i++){ var el = q(root, selectors[i]); if (el) return el; } return null; }

  function bestImageURL(card){
    /* 1) <picture><source srcset=...></picture> */
    var sources = qAll(card, 'picture source[srcset]');
    for (var i = 0; i < sources.length; i++){
      var ss = sources[i].getAttribute('srcset') || '';
      if (ss){
        var parts = ss.split(',').map(function(s){return s.trim().split(' ')[0];}).filter(Boolean);
        if (parts.length){
          /* Pick the middle resolution - typically the medium image */
          var pick = parts[Math.min(parts.length-1, Math.floor(parts.length/2))];
          if (pick && pick.indexOf('data:') !== 0) return pick;
        }
      }
    }
    /* 2) <img srcset=...> */
    var imgs = qAll(card, 'img');
    for (var j = 0; j < imgs.length; j++){
      var img = imgs[j];
      var srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
      if (srcset){
        var p2 = srcset.split(',').map(function(s){return s.trim().split(' ')[0];}).filter(Boolean);
        if (p2.length){
          var pick2 = p2[Math.min(p2.length-1, Math.floor(p2.length/2))];
          if (pick2 && pick2.indexOf('data:') !== 0) return pick2;
        }
      }
    }
    /* 3) img src / currentSrc / data-src */
    for (var k = 0; k < imgs.length; k++){
      var im = imgs[k];
      var u = im.currentSrc || im.src || im.getAttribute('data-src') || im.getAttribute('data-lazy') || '';
      if (u && u.indexOf('data:') !== 0) return u;
    }
    /* 4) inline background-image */
    var bgEls = qAll(card, '[style*="background-image"]');
    for (var l = 0; l < bgEls.length; l++){
      var m = (bgEls[l].getAttribute('style') || '').match(/url\(['"]?([^'")]+)['"]?\)/);
      if (m && m[1] && m[1].indexOf('data:') !== 0) return m[1];
    }
    return '';
  }

  function getTitle(card){
    var el = qOne(card, ['.card-product__title a','.card__heading a','.product-card__title a','.product-card-title a','.card-information__title a','h3 a','h2 a','.card-product__title','.card__heading','.product-card__title','.product-card-title','h3','h2','[class*="product-card__title"]','[class*="card-product__title"]','[class*="card__heading"]']);
    if (el) { var t = (el.textContent || '').trim(); if (t) return t; }
    /* Fallback: link href text */
    var a = q(card, 'a[href*="/products/"]');
    if (a){ var t2 = (a.textContent || '').replace(/\s+/g,' ').trim(); if (t2 && !/^(Rs\.|₹|\$)/.test(t2)) return t2; }
    return '';
  }

  function getURL(card){
    var a = q(card, 'a[href*="/products/"]');
    if (a) return a.getAttribute('href');
    if (card.matches && card.matches('a[href*="/products/"]')) return card.getAttribute('href');
    return '#';
  }

  function getPrice(card){
    var saleEl = q(card, '.price-item--sale, .price__sale .price-item--regular, .price--on-sale .price-item--regular');
    var regularEl = q(card, '.price-item--regular, .price__regular, .price__current');
    var compareEl = q(card, 's.price-item, .price-item--last, .price__regular .price-item--regular');
    var sale = saleEl ? (saleEl.textContent || '').trim() : '';
    var regular = regularEl ? (regularEl.textContent || '').trim() : '';
    var compare = compareEl ? (compareEl.textContent || '').trim() : '';
    if (!sale && !regular){
      var priceContainer = q(card, '.price, [class*="price"]:not([class*="compare"])');
      if (priceContainer){
        regular = (priceContainer.textContent || '').replace(/\s+/g,' ').trim();
        var parts = regular.split(/\s{2,}|\n+/).map(function(s){return s.trim();}).filter(Boolean);
        if (parts.length > 1 && parts[0] === parts[1]) regular = parts[0];
      }
    }
    if (!sale && !regular){
      var match = (card.textContent || '').match(/(Rs\.?\s*[0-9,.]+|₹\s*[0-9,.]+|\$[0-9,.]+)/);
      if (match) regular = match[1];
    }
    var html = '';
    if (sale && compare && sale !== compare){ html = '<span class="evd-pc__price--sale">'+sale+'</span><span class="evd-pc__price--compare">'+compare+'</span>'; }
    else if (compare && regular && compare !== regular){ html = '<span class="evd-pc__price--sale">'+regular+'</span><span class="evd-pc__price--compare">'+compare+'</span>'; }
    else { var p = sale || regular || compare; var seen = {}; var dedup = (p||'').split(/(?=Rs\.|₹|\$)/g).map(function(s){return s.trim();}).filter(function(s){ if (!s) return false; if (seen[s]) return false; seen[s] = 1; return true; }).join(' '); html = '<span class="evd-pc__price--regular">'+(dedup||p||'')+'</span>'; }
    return html;
  }

  function getBadge(card){
    var el = qOne(card, ['.card__badge','.card-product__badge','.product-card__badge','.badge:not([class*="evdm"])','[class*="badge--sale"]','[class*="sale-badge"]']);
    if (!el) return '';
    var txt = (el.textContent || '').trim();
    if (!txt) return '';
    if (txt.length > 12) txt = txt.slice(0,12);
    return '<span class="evd-pc__badge">'+txt+'</span>';
  }

  function rebuild(card){
    if (card.dataset.evdPc === '1') return;
    var url = getURL(card);
    /* Only rebuild things that actually link to a product */
    if (url === '#') return;
    var title = getTitle(card);
    if (!title) return;
    var imgURL = bestImageURL(card);
    var priceHtml = getPrice(card);
    var badgeHtml = getBadge(card);
    card.dataset.evdPc = '1';
    card.classList.add('evd-pc-host');
    var imgStyle = imgURL ? 'background-image:url(\''+imgURL.replace(/'/g, "\\'") +'\')' : 'background:linear-gradient(135deg,#fef2f2,#fff)';
    card.innerHTML =
      '<a class="evd-pc" href="'+url+'">' +
        badgeHtml +
        '<span class="evd-pc__img" style="'+imgStyle+'">' +
          (imgURL ? '' : '<span class="evd-pc__img-fallback">EVD</span>') +
        '</span>' +
        '<span class="evd-pc__body">' +
          '<span class="evd-pc__title">'+title+'</span>' +
          '<span class="evd-pc__price">'+priceHtml+'</span>' +
        '</span>' +
      '</a>';
  }

  /* On the search page, find EVERY card-like container and rebuild it */
  function scanSearchPage(){
    var isSearch = (document.body.classList.contains('template-search') || /\/search/.test(location.pathname));
    if (!isSearch) return;
    /* Strategy: every product-link ancestor with siblings is a card. */
    var productLinks = document.querySelectorAll('main a[href*="/products/"]');
    var seen = new WeakSet();
    productLinks.forEach(function(link){
      /* Desi Pop sections (.dp) render their own product cards (dp-pcard); never rebuild those. */
      if (link.closest('.dp')) return;
      /* Walk up until we find a container that is ALSO a sibling of OTHER product cards */
      var card = link;
      for (var depth = 0; depth < 6 && card && card !== document.body; depth++){
        var parent = card.parentElement;
        if (!parent) break;
        var siblingCardCount = 0;
        for (var s = 0; s < parent.children.length; s++){
          if (parent.children[s].querySelector && parent.children[s].querySelector('a[href*="/products/"]')) siblingCardCount++;
        }
        if (siblingCardCount >= 2) { break; }
        card = parent;
      }
      if (!card || seen.has(card)) return;
      seen.add(card);
      rebuild(card);
    });

    /* Force grid to 2-col */
    var grids = document.querySelectorAll('main [class*="grid"], main ul[role="list"], main resource-list, .search-page__grid, .search-results__grid, .search__grid');
    grids.forEach(function(g){
      if (g.querySelectorAll('.evd-pc-host').length >= 1){
        g.style.cssText += ';display:grid !important;grid-template-columns:repeat(2,minmax(0,1fr)) !important;gap:12px !important;padding:12px !important;list-style:none !important;width:100% !important;max-width:100vw !important;';
      }
    });
  }

  function scanAll(){
    if (!document.body) return;
    if (!isMobile()) return;
    var cards = document.querySelectorAll('product-card, .product-card, .card-product, .resource-list__item, .card-wrapper, .card.card--product, .product-item');
    cards.forEach(rebuild);
    scanSearchPage();
  }

  function watch(){
    if (!document.body || !window.MutationObserver) return;
    var st;
    new MutationObserver(function(m){
      var hasNew = false;
      for (var i = 0; i < m.length; i++){ if (m[i].addedNodes && m[i].addedNodes.length){ hasNew = true; break; } }
      if (hasNew){ clearTimeout(st); st = setTimeout(scanAll, 150); }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function boot(){ scanAll(); watch(); }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('resize', function(){ clearTimeout(window.__evdPcResize); window.__evdPcResize = setTimeout(scanAll, 200); });
})();
